import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function StormApproachTrendGuide() {
  return <LocalizedWeatherGuidePage guideKey="stormApproachTrend" />;
}